<div  class="wrapper has-padding success-wrap">
	<h1 class="bofa--heading is-4">Success: Your profile was created</h1>

 <div class="bofa--alert has-background cool-gray-5 has-padding is-stacked">
    <span> <img alt="information" src="assets/bofa_icon_info.svg" class="img-size"></span>
    <span>If you have trouble accessing your application, please</span><br />
    <span>reach out to the contact listed in your invitation email.</span>
  </div>

  <div class="bofa--action_bar is-taller">
			<button (click)="navigateLogin()"  class="bofa--button primary large">Login</button>
	</div>

  </div>
